import { render, staticRenderFns } from "./InputPanel.vue?vue&type=template&id=b08b430c&scoped=true"
import script from "./InputPanel.vue?vue&type=script&lang=js"
export * from "./InputPanel.vue?vue&type=script&lang=js"
import style0 from "./InputPanel.vue?vue&type=style&index=0&id=b08b430c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b430c",
  null
  
)

export default component.exports